<template>
  <div v-if="role.bestuurder">
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnTerug" class="btn btn-primary btn-xs" @click.prevent="btnTerug">
          <font-awesome-icon icon="chevron-left" />
          {{ translation(16881) }}
        </button>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-12">
        <span id="lblTitel" class="titel">{{ translation(16872) }}</span>
      </div>
    </div>
    <div class="row lblBeschrijving" v-if="translation(16873) !== ''">
      <div class="col-12">
        <p v-html="translation(16873)"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <fieldset>
          <div class="row margin20">
            <div class="col-12">
              <span>{{ translation(16875) }}</span>
              <span>
                <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
              </span>
            </div>
          </div>
          <div class="row ">
            <div
              class="col-12 form-group has-feedback"
              v-bind:class="{
                'form-group--error': errors.has('tbxSubject')
              }"
            >
              <XVinput
                id="tbxSubject"
                key="tbxSubject"
                name="tbxSubject"
                v-model="formInputMessage.subject"
                v-validate="'required'"
                :data-vv-as="translation(16875)"
                type="text"
              ></XVinput>
              <span class="form-group__message">{{ errors.first('tbxSubject') }}</span>
            </div>
          </div>
          <div class="row ">
            <div class="col-12">
              <span>{{ translation(16876) }}</span>
              <span>
                <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
              </span>
            </div>
          </div>
          <div class="row ">
            <div
              class="col-12 form-group has-feedback"
              v-bind:class="{
                'form-group--error': errors.has('tbxMessageBody')
              }"
            >
              <XVtextarea
                id="tbxMessageBody"
                name="tbxMessageBody"
                v-validate="'required'"
                :data-vv-as="translation(16876)"
                v-model="formInputMessage.messageBody"
              ></XVtextarea>
              <span class="form-group__message">{{ errors.first('tbxMessageBody') }}</span>
            </div>
          </div>
          <div class="row margin20bottom">
            <div class="col-12">
              <button
                type="button"
                id="btnVerstuur"
                class="btn btn-primary btn-xs"
                @click.prevent="btnVerstuur"
                :disabled="btnToggles.btnVerstuur"
              >
                <font-awesome-icon :icon="['far', 'envelope']" />
                {{ translation(16874) }}
              </button>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  data: function() {
    return {}
  },
  async mounted() {
    await this.getRole()
  },
  computed: {
    ...mapGetters('SRPOOvereenkomsten', ['role', 'srpoTable', 'formInputMessage', 'btnToggles'])
  },
  methods: {
    ...mapMutations(['addNotification']),
    ...mapMutations('SRPOOvereenkomsten', ['toggleBtnVerstuur']),
    ...mapActions('SRPOOvereenkomsten', ['getRole', 'getTexten', 'stuurBericht']),
    btnTerug() {
      this.$router.push({ name: 'overzicht' })
    },
    btnVerstuur() {
      this.toggleBtnVerstuur(true)
      this.$validator.validate().then(result => {
        if (result) {
          let prop = {
            Subject: this.formInputMessage.subject,
            MessageBody: this.formInputMessage.messageBody.replace(/(?:\r\n|\r|\n)/g, '<br>')
          }
          this.stuurBericht(prop)
        } else {
          this.toggleBtnVerstuur(false)
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642)
          })
        }
      })
    }
  }
}
</script>

<style scoped></style>
